/**
 * What can happen to a channel's message, as its activity log types name it: the `sent` in
 * `sent_email`. Each event's phrase starts the log type's name, which ends with the channel's
 * noun ("Sent" + "email").
 */
export const CHANNEL_EVENT_PHRASES = {
  attempted: 'Attempted to send',
  sent: 'Sent',
  delivered: 'Delivered',
  deferred: 'Deferred',
  failed: 'Failed to send',
  bounced: 'Bounced',
  opened: 'Opened',
  clicked: 'Clicked',
  converted: 'Converted',
  drafted: 'Drafted',
  // Email logs a suppressed message as `dropped`, SMS as `suppressed`; both read "Suppressed".
  dropped: 'Suppressed',
  suppressed: 'Suppressed',
  undeliverable: 'Undeliverable',
  unsubscribed: 'Unsubscribed',
  topic_unsubscribed: 'Topics unsubscribed',
  spammed: 'Spammed',
  replied: 'Replied to',
} as const;

export type ChannelEvent = keyof typeof CHANNEL_EVENT_PHRASES;
